/**
 * Guide step 3: badges.
 */
import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";

import { useAsterController } from 'context';
import { VText, VImage } from "form";

/**
 * Explains quiz badges for the course.
 */
const Guide3 = () => {

  const { t } = useTranslation('common');

  const { courseId } = useParams();

  const [controller] = useAsterController();
  const { courses } = controller;

  const badgeCounter = useMemo(() => {
    const currCourse = (courses.data || []).find(v => v.id === courseId) || { moduleMapper: [] };
    const counter = (currCourse.moduleMapper || []).filter(m => m.gradeFormat && m.gradeFormat.toLowerCase() === 'quiz').length;
    return counter;
  }, [courseId, courses.data]);

  return <Box className="flex flex-col md:flex-row justify-center items-center w-full max-w-screen-xl mx-auto gap-10 md:py-10">
    <Box className="flex justify-center items-center md:w-6/12 w-full">
      <VImage src={`${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/guide/guide3.svg`} className="w-full max-w-sm" draggable={false} />
    </Box>
    <Box className="flex flex-col gap-1 md:w-6/12 w-full">
      <VText className="text-4xl mb-5">{t("Validate the")} {badgeCounter} {t("modules to access the final assessment")}</VText>
      <VText className="text-2xl">{t("At the end of each module, you pass a quiz to earn a module badge.")}</VText>
      <VText className="text-2xl">{t("You therefore have")} {badgeCounter} {t("module badges to collect to finish and validate your training.")}</VText>
      <VText className="text-2xl">{t("That's it, you have obtained the")} {badgeCounter} {t("module badges and now have access to your final evaluation.")}</VText>
      <VText className="text-2xl">{t("You pass your final assessment and get your certificate of achievement.")}</VText>
      <VText className="text-2xl">{t("It's time to register for the official passage of your certification by filling out your application for passing the exam.")}</VText>
    </Box>
  </Box>;
};

export default Guide3;